
import Homepage from './components/Homepage';
import RestPage from './components/RestPage';
import { Route, Routes, useLocation, useNavigate } from 'react-router-dom';
import { useEffect } from 'react';
import { useTranslation } from "react-i18next";
import NotFound from './components/NotFound';

import './css/style.css';

const App = () => {
    const { i18n } = useTranslation();
    const location = useLocation();
    const navigate = useNavigate();

    useEffect(() => {
        const langFromPath = location.pathname.split('/')[1];

        if(langFromPath === 'en' || langFromPath === 'lv'){
            i18n.changeLanguage(langFromPath);
            localStorage.setItem('language', langFromPath);
            const newPath = location.pathname.substring(langFromPath.length + 1);
            navigate(newPath || '/', { replace: true })
        }
    }, [i18n, location.pathname, navigate]);

    return(
        <>
            <Routes>
                <Route path="/" element={ <Homepage /> } />
                <Route path="/izbraukumi" element={ <Homepage sectionId="izbraukumi" seoPage="bus" /> } />
                <Route path="/tirgus" element={ <Homepage sectionId="tirgus" seoPage="garden" /> } />
                <Route path="/parmums" element={ <Homepage sectionId="parmums" seoPage="aboutus" /> } />
                <Route path="/kokteili" element={ <Homepage sectionId="kokteili" seoPage="cocktails" /> } />
                <Route path="/united" element={ <Homepage sectionId="united" seoPage="united" /> } />
                <Route path="/buj" element={ <Homepage sectionId="buj" seoPage="faq" /> } />
                <Route path=":rest" element={ <RestPage /> } />
                <Route path="*" element={ <NotFound /> } />
            </Routes>
        </>
    )
}

export default App;
